import type {
	Components,
} from '@mui/material'

export const materialUICardTheme: {
	components: Components
} = {
	components: {
		MuiCard: {
			styleOverrides: {
				root: {
					backgroundColor: 'transparent',
				},
			},
		},

	},
}
